import { TYPES } from './constants';

export function renderVideo(renderContext, node) {
  if (node.type !== TYPES.video) return;
}
